export default __webpack_public_path__ + "static/media/spin5.9ae6280d.png";